import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {ProductStatus} from "../../models/change-status/productStatus";

/**
 * Generated class for the PopoverProductStatusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-product-status',
  templateUrl: 'popover-product-status.html',
})
export class PopoverProductStatusPage {

  statusList: ProductStatus[] = [];
  selectedStatus: ProductStatus = new ProductStatus();

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public viewCtrl: ViewController) {
    this.statusList = navParams.get('statusList');
    this.selectedStatus = navParams.get('selectedStatus');
  }

  ionViewDidLoad() {
  }

  statusSelected(selectedStatus: ProductStatus) {
    this.selectedStatus = selectedStatus;
    this.viewCtrl.dismiss(this.selectedStatus);
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-product-status/popover-product-status.ts